<template>
  <div
    class="d-flex flex-column align-start justify-start table-content"
    :class="{ 'disable-share': disableShare || authData.noEditorEnabled, pagination: totalPages > 1 }"
  >
    <v-data-table
      v-if="documents.length"
      :model-value="selectedJobs"
      :headers="headers"
      :items="documents"
      height="100%"
      width="100%"
      :show-select="!disableShare && !authData.noEditorEnabled"
      :must-sort="false"
      :items-per-page="documents.length || 20"
      return-object
      @update:model-value="handleUpdateSelected"
      @click:row="navigateToJob"
    >
      <template #top>
        <TableContentHeader
          class="sticky-table-content-header"
          :documents="documents"
          :table-label="tableLabel"
          :selected-jobs="selectedJobs"
          :disable-share="disableShare || authData.noEditorEnabled"
          @share="$emit('share')"
        />
        <StickyTable
          :all-selected="allSelected"
          :headers="headers"
          :disable-share="disableShare || authData.noEditorEnabled"
          :other-number-of-columns="otherNumberOfColumns"
          @select-all="handleSelectAll"
        />
      </template>
      <template #[`header.issues.salary`]>
        <span class="missing-statement-header">Salary</span>
      </template>
      <template #[`header.issues.jobBoardUnoptimized`]>
        <span class="missing-statement-header">Optimization</span>
      </template>
      <template #[`header.issues.diversityAccomodation`]>
        <span class="missing-statement-header">Diversity/Accommodation</span>
      </template>
      <template #[`header.issues.incomplete`]>
        <span class="missing-statement-header">Complete</span>
      </template>
      <template #[`header.issues.benefits`]>
        <span class="missing-statement-header">Benefits</span>
      </template>
      <template #[`header.issues.long`]>
        <span class="missing-statement-header">Length</span>
      </template>
      <template #[`header.issues.reporting_structure`]>
        <span class="missing-statement-header">Reporting</span>
      </template>
      <template #[`header.issues.nonCompliantEVP`]>
        <span class="missing-statement-header">EVP</span>
      </template>
      <template #[`header.issues.regulatoryGuidance`]>
        <span class="missing-statement-header">Regulatory</span>
      </template>
      <template #[`header.issues.exclusionaryLanguage`]>
        <span class="missing-statement-header">Exclusionary</span>
      </template>
      <template #[`header.issues.unclearLocation`]>
        <span class="missing-statement-header">Location</span>
      </template>
      <template #[`header.issues.unoptimized_title`]>
        <span class="missing-statement-header">Title</span>
      </template>
      <template #[`header.issues.experience`]>
        <span class="missing-statement-header">Experience</span>
      </template>
      <template #[`header.issues.preferred_requirements`]>
        <span class="missing-statement-header">Requirements</span>
      </template>
      <template #[`item.is_internal`]="{ item }">
        <JobBadges
          class="d-flex justify-end"
          :is-internal="item.is_internal"
          :is-evergreen="item.is_evergreen"
        />
      </template>
      <template
        #[`item.data-table-select`]="{
          item, toggleSelect, isSelected, internalItem,
        }"
      >
        <DpplSimpleCheckbox
          v-if="!disableShare"
          :model-value="isSelected(internalItem)"
          :option="{ id: item.id, label: `Select ${item.title || 'profile'}` }"
          hide-label
          size="md"
          border-radius="6px"
          class="checkbox document-checkbox"
          @click.stop
          @update:model-value="toggleSelect(internalItem)"
        />
      </template>
      <template #[`item.title`]="{ item }">
        <div class="d-flex align-center justify-start w-100">
          <NoEditorWrapper :redirect-route="isSharedPage ? undefined : { query: { preview: item.id, type: 'document' } }">
            <DocumentScoreLink
              :id="item.id"
              :score="item.score_total_capped"
              :language-code="item.language_code"
              :disable-link="isSharedPage"
              class="mr-4"
            />
          </NoEditorWrapper>
          <div class="d-flex flex-column align-start justify-start py-3 w-100 overflow-x-hidden">
            <div class="mb-1 w-100 d-flex align-center">
              <p class="job-title ellipsis-text">
                {{ item.title }}
              </p>
            </div>
            <div class="d-flex align-center justify-start cell-text ellipsis-text w-100">
              <span v-if="item.company" :class="{ 'ellipsis-text': !item.location }">{{ item.company }}</span>
              <span
                v-if="item.company && item.location"
                class="mx-1"
              >-</span>
              <span v-if="item.location" class="ellipsis-text">{{ item.location }}</span>
              <span
                v-if="(item.company || item.location) && item.ats_requisition_id"
                class="mx-1"
              >-</span>
              <span v-if="item.ats_requisition_id" class="ellipsis-text">{{ item.ats_requisition_id }}</span>
            </div>
          </div>
        </div>
      </template>
      <template #[`item.issues.salary`]="{ item }">
        <ActionableInsightIcon
          class="cell-text divider missing-statement"
          :mood="item.issues.salary"
        />
      </template>
      <template #[`item.issues.jobBoardUnoptimized`]="{ item }">
        <ActionableInsightIcon
          class="cell-text divider missing-statement"
          :mood="item.issues.jobBoardUnoptimized"
        />
      </template>
      <template #[`item.issues.diversityAccomodation`]="{ item }">
        <ActionableInsightIcon
          class="cell-text divider missing-statement"
          :mood="item.issues.diversityAccomodation"
        />
      </template>
      <template #[`item.issues.accommodation`]="{ item }">
        <ActionableInsightIcon
          class="cell-text divider missing-statement"
          :mood="item.issues.accommodation"
        />
      </template>
      <template #[`item.issues.incomplete`]="{ item }">
        <ActionableInsightIcon
          class="cell-text divider missing-statement"
          :mood="item.issues.incomplete"
        />
      </template>
      <template #[`item.issues.benefits`]="{ item }">
        <ActionableInsightIcon
          class="cell-text divider missing-statement"
          :mood="item.issues.benefits"
        />
      </template>
      <template #[`item.issues.long`]="{ item }">
        <ActionableInsightIcon
          class="cell-text divider missing-statement"
          :mood="item.issues.long"
        />
      </template>
      <template #[`item.issues.reporting_structure`]="{ item }">
        <ActionableInsightIcon
          class="cell-text divider missing-statement"
          :mood="item.issues.reporting_structure"
        />
      </template>
      <template #[`item.issues.nonCompliantEVP`]="{ item }">
        <ActionableInsightIcon
          class="cell-text divider missing-statement"
          :mood="item.issues.nonCompliantEVP"
        />
      </template>
      <template #[`item.issues.regulatoryGuidance`]="{ item }">
        <ActionableInsightIcon
          class="cell-text divider missing-statement"
          :mood="item.issues.regulatoryGuidance"
        />
      </template>
      <template #[`item.issues.exclusionaryLanguage`]="{ item }">
        <ActionableInsightIcon
          class="cell-text divider missing-statement"
          :mood="item.issues.exclusionaryLanguage"
        />
      </template>
      <template #[`item.issues.unclearLocation`]="{ item }">
        <ActionableInsightIcon
          class="cell-text divider missing-statement"
          :mood="item.issues.unclearLocation"
        />
      </template>
      <template #[`item.issues.unoptimized_title`]="{ item }">
        <ActionableInsightIcon
          class="cell-text divider missing-statement"
          :mood="item.issues.unoptimized_title"
        />
      </template>
      <template #[`item.issues.experience`]="{ item }">
        <ActionableInsightIcon
          class="cell-text divider missing-statement"
          :mood="item.issues.experience"
        />
      </template>
      <template #[`item.issues.preferred_requirements`]="{ item }">
        <ActionableInsightIcon
          class="cell-text divider missing-statement"
          :mood="item.issues.preferred_requirements"
        />
      </template>
      <template #[`item.created_by`]="{ item }">
        <div class="d-flex align-center justify-start cell-text ellipsis-text w-100">
          <span v-if="item.created_by" class="ellipsis-text text-textDark text-caption">{{ item.created_by }}</span>
        </div>
      </template>
      <template #[`item.recruiters`]="{ item }">
        <div class="cell-text divider">
          <div v-if="item.recruiters.length <= 3" class="d-flex flex-column align-start justify-start">
            <span
              v-for="recruiter in item.recruiters"
              :key="recruiter"
            >{{ recruiter }}</span>
          </div>
          <DpplTooltip
            v-else
          >
            <template #activator="{ onMouseenter, onMouseleave }">
              <span
                @mouseenter="onMouseenter"
                @mouseleave="onMouseleave"
              >
                {{ `${item.recruiters.length} Recruiters` }}
              </span>
            </template>
            <template #tooltip-content>
              <div class="d-flex flex-column align-start justify-start">
                <span
                  v-for="recruiter in item.recruiters"
                  :key="recruiter"
                >{{ recruiter }}</span>
              </div>
            </template>
          </DpplTooltip>
        </div>
      </template>
      <template #bottom>
        <Pagination
          v-if="totalPages > 1"
          class="mb-4 px-2"
          :model-value="page"
          :length="totalPages"
          @update:model-value="(value) => sendFilterRequest({ pageNumber: value, router: $router })"
        />
      </template>
    </v-data-table>
    <div
      v-else
      class="no-results-container"
    >
      <NoResultsFound />
      <div class="no-results-content">
        <slot name="noResultsFoundText" />
      </div>
    </div>
  </div>
</template>

<script>
import Pagination from '@/components/shared/Pagination.vue';
import { mapState, mapActions } from 'pinia';
import { useAppAuthData } from '@/stores/app/authData';
import { useAppPagination } from '@/stores/app/pagination';
import TableContentHeader from '@/components/insights/ActionableInsight/TableContentHeader.vue';
import StickyTable from '@/components/insights/ActionableInsight/StickyTable.vue';
import { useFilters } from '@/stores/filters/filters';
import DpplTooltip from '@/components/datapeople/DpplTooltip.vue';
import JobBadges from '@/components/editor/badge/JobBadges.vue';
import DocumentScoreLink from '@/components/shared/DocumentScoreLink.vue';
import { startCase } from 'lodash-es';
import NoEditorWrapper from '@/components/editor/NoEditorWrapper.vue';
import DpplSimpleCheckbox from '@/components/datapeople/DpplSimpleCheckbox.vue';
import NoResultsFound from '@/assets/actionable-no-results.svg?component';
import ActionableInsightIcon from './ActionableInsightIcon.vue';

export default {
  name: 'TableContent',
  components: {
    Pagination,
    NoResultsFound,
    ActionableInsightIcon,
    TableContentHeader,
    StickyTable,
    DpplTooltip,
    JobBadges,
    DocumentScoreLink,
    NoEditorWrapper,
    DpplSimpleCheckbox,
  },
  props: {
    documents: {
      type: Array,
      default() {
        return [];
      },
    },
    selectedJobs: {
      type: Array,
      default() {
        return [];
      },
    },
    statements: {
      type: Array,
      default() {
        return [];
      },
    },
    tableLabel: {
      type: String,
      default: '',
    },
    disableShare: {
      type: Boolean,
      default: false,
    },
    documentType: {
      type: String,
      default: 'job',
    },
    isSharedPage: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['updateSelected', 'share', 'selectAll'],
  data() {
    return {
      iconHovered: null,
    };
  },
  computed: {
    ...mapState(useAppPagination, ['page', 'totalPages']),
    ...mapState(useAppAuthData, ['authData']),
    allSelected() {
      return this.documents
        .every(({ id }) => this.selectedJobs.some(({ id: jobId }) => jobId === id));
    },
    otherNumberOfColumns() {
      return this.headers.length - 3;
    },
    totalDocuments() {
      return this.documents.length;
    },
    headers() {
      const defaultHeaders = [
        {
          text: `${startCase(this.documentType)} Title`,
          align: 'start',
          value: 'title',
        },
        {
          text: '',
          align: 'end',
          value: 'is_internal',
        },
        ...this.statements,
      ];

      if (this.documentType === 'job') {
        defaultHeaders.push({
          text: 'Recruiters',
          align: 'start',
          value: 'recruiters',
        });
      } else {
        defaultHeaders.push({
          text: 'Created By',
          align: 'start',
          value: 'created_by',
        });
      }

      return defaultHeaders;
    },
  },
  methods: {
    ...mapActions(useFilters, ['sendFilterRequest']),
    navigateToJob(_, row) {
      const { item } = row;

      if (this.isSharedPage) return;
      this.$router.replace({ query: { preview: item.id, type: 'document' } });
    },
    handleUpdateSelected(event) {
      this.$emit('updateSelected', event);
    },
    handleSelectAll() {
      if (this.allSelected) this.$emit('selectAll', []);
      else this.$emit('selectAll', this.documents);
    },
  },
};
</script>

<style lang="less" scoped>
.table-content {
  width: 100%;
  min-height: 300px;

  .v-theme--light.v-data-table {
    width: 100%;
    border-radius: 8px;
  }

  :deep(.v-selection-control__input)::before {
    color: @text-brand;
  }

  :deep(.v-selection-control).v-selection-control--dirty i, :deep(.v-selection-control).v-selection-control--dirty path {
    color: @text-light;
    font-size: 21px;
    fill: @text-brand;
  }

  :deep(.v-selection-control--dirty) i {
    color: @text-brand;
  }
}

.sticky-table-content-header {
  position: sticky;
  top: 132px;
  z-index: 2;
}

:deep(.v-data-table__td--select-row) {
  padding: 0 !important;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

:deep(.v-table__wrapper):not(.sticky-table-header) thead tr {
  display: none;
}

// Hide the row on all browsers while still allowing it to set the column widths
:deep(.v-data-table-header:not(.sticky-thead)) {
  visibility: collapse;
  line-height: 0;

  * {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
    border: none !important;
    height: 0px !important;
  }
}

.no-results-container {
  width: 100%;
  height: 396px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .no-results-content {
    transform: translateY(-95px);
    text-align: center;
    color: @text-light;
  }
}

.cell-text {
  font-size: 12px;
  line-height: 16px;
}

:deep(.share-button:not(.v-btn--disabled)) path {
  fill: @white;
}

:deep(td) {
  border-bottom: 1px solid @stroke-default !important;
}

:deep(td:has(.divider)), td:has(.divider) {
  padding: 17px 24px !important;
}

:deep(td:has(.missing-statement)) {
  width: 95px;
  display: flex;
  align-items: center;
  justify-content: center;
}

:deep(.missing-statement-header) {
  padding: 0px !important;
  transform: translateX(-16px);
  display: flex;
  align-items: center;
  justify-content: center;
  width: 95px !important;
  min-width: 95px !important;

  span {
    width: 100%;
  }
}

:deep(tbody) tr:active, :deep(tbody) tr.v-data-table__selected {
  background: @white !important;
}

:deep(table) {
  display: grid;
  grid-template-columns: 42px minmax(180px, 715px) 116px repeat(v-bind(otherNumberOfColumns), minmax(90px, 95px)) minmax(85px, 266px);

  tbody, tr {
    display: contents;
  }

  tr:hover td {
    box-shadow: 0px 10px 20px @bg-canvas;
  }

  thead {
    display: none;
  }

  td {
    height: 68px !important;
    width: 100% !important;
    display: flex;
    align-items: center;

    &:not(:last-child):not(:nth-child(2)) {
      border-right: 1px solid @stroke-default;
    }
  }
}

:deep(tr):last-child td {
  border-bottom: none !important;
}

.pagination :deep(tr):last-child td {
  border-bottom: 1px solid @stroke-default !important;
}

.ellipsis-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.disable-share :deep(table) {
  grid-template-columns: minmax(180px, 715px) 116px repeat(v-bind(otherNumberOfColumns), minmax(90px, 95px)) minmax(85px, 266px);

  td:not(:last-child):not(:first-child) {
    border-right: 1px solid @stroke-default;
  }

  td:first-child {
    border-right: none;
  }
}

.job-title {
  font-weight: 500;
  font-size: 15px;
  line-height: 20px;
}
</style>
